import { apiEndpoint } from 'configs'
import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const postEditProfile = createAsyncThunk(
  'setting/getTeam',
  async ({ name }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const { data } = await axios.patch(
        `${apiEndpoint}/api/v1/bussines/profile`,
        { name },
        config,
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const postEditEmploymentData = createAsyncThunk(
  'setting/editEmploymentData',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const { data } = await axios.patch(
        `${apiEndpoint}/api/v1/bussines/profile`,
        payload,
        config,
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)
